//Import scripts
import "./components/scroll-navigation";
import "./components/pubg-filter";
import "./components/tournament-slider";

//Import modules
import "./modules/Datepicker";
import "./modules/Ajax-brackets";
import "./modules/Ajax-twitch-streams";

//Import layouts
import "./layouts/tournaments-page";



// WEBPACK FOOTER //
// ./scripts/tournament-page.js